import script from "./InputSelect.vue?vue&type=script&lang=ts&setup=true"
export * from "./InputSelect.vue?vue&type=script&lang=ts&setup=true"

import "./InputSelect.vue?vue&type=style&index=0&id=e82d318a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\ayaka_kitahara\\source\\pcare\\src\\ui-iikum\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e82d318a"]])

export default __exports__